import { MobileVoicePageV2 } from "./MobileVoicePageV2";

/** `/m/voice`: the live-transcription voice experience. */
export function MobileVoiceGate() {
  return <MobileVoicePageV2 />;
}

export default MobileVoiceGate;
